<template>
    <li :class="navItemClassObject">
        <a :class="classObject" :href="link" v-if="!!link">
            <div class="nav-icon" v-if="icon">
                <font-awesome-icon :icon="icon"></font-awesome-icon>
            </div>
            <div class="nav-title headline-font">
                {{ title }}
            </div>
        </a>

        <span :class="classObject" v-else>
            <div class="nav-icon" v-if="icon">
                <font-awesome-icon :icon="icon"></font-awesome-icon>
            </div>
            <div class="nav-title headline-font">{{ title }}</div>
        </span>

        <slot v-if="subMenu"></slot>
    </li>
</template>

<script>
export default {
    props: {
        icon: {
            type: Array,
            default: null,
            required: false
        },
        title: {
            type: String,
            default: null,
            required: true
        },
        link: {
            type: String,
            default: null,
            required: false
        },
        active: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    computed: {
        navItemClassObject: function() {
            return {
                "nav-item": true,
                "has-sub": !!this.subMenu
            };
        },
        classObject: function() {
            return {
                "nav-link": true,
                active: !!this.active
            };
        },
        subMenu: function() {
            return !this.link && !!this.$slots.default;
        }
    }
};
</script>
